/* istanbul ignore file */
export default {
  rejectionReason: {
    type: 'string',
    required: {
      value: true,
      message: 'Please select the rejection reason',
    },
  },
};
